/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Scene_DescriptionInputs */

const en_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SCENE DESCRIPTION`)
};

const fr_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIPTION DE LA SCENE`)
};

const de_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szenenbeschreibung`)
};

const it_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIZIONE DELLA SCENA`)
};

const ru_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОПИСАНИЕ СЦЕНЫ`)
};

const es_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIPCIÓN DE LA ESCENA`)
};

const zh_cn2_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景描述`)
};

const ja_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーンの説明`)
};

const hi_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दृश्य का विवरण`)
};

const pt_pt2_ccsl_export_header_scene_description = /** @type {(inputs: Ccsl_Export_Header_Scene_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIÇÃO DA CENA`)
};

/**
* | output |
* | --- |
* | "SCENE DESCRIPTION" |
*
* @param {Ccsl_Export_Header_Scene_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_scene_description = /** @type {((inputs?: Ccsl_Export_Header_Scene_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Scene_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_scene_description(inputs)
	if (locale === "de") return de_ccsl_export_header_scene_description(inputs)
	if (locale === "it") return it_ccsl_export_header_scene_description(inputs)
	if (locale === "ru") return ru_ccsl_export_header_scene_description(inputs)
	if (locale === "es") return es_ccsl_export_header_scene_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_scene_description(inputs)
	if (locale === "ja") return ja_ccsl_export_header_scene_description(inputs)
	if (locale === "hi") return hi_ccsl_export_header_scene_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_scene_description(inputs)
	return en_ccsl_export_header_scene_description(inputs)
});